import { trackRetailersPageViewView } from "@faire/web-api/events/retailers/view/pageView";
import { QueryParameters as BrandPageQueryParameters } from "@faire/web-api/routes/brand/brandToken";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  recordLandingActivity,
  recordSignupActivity,
} from "@faire/retailer/actions/user/recordLoggedOutActivity";

export function useLoggedOutBrandTracking(brandToken: string) {
  const { pathname } = useLocation();
  const { refP } = useQueryParams(BrandPageQueryParameters.parse);

  useEffect(() => {
    recordLandingActivity({
      brand_token: brandToken,
      product_token: (refP as string) ?? undefined,
    });
    recordSignupActivity(
      {
        brand_token: brandToken,
        product_token: (refP as string) ?? undefined,
      },
      pathname
    );
  }, [brandToken, refP, pathname]);

  useEffect(() => {
    trackRetailersPageViewView(
      brandToken,
      "",
      "",
      "brand",
      pathname,
      "page-brand-logged-out"
    );
  }, [brandToken, pathname]);
}
